import React from 'react';
import ReactDOM from 'react-dom';
//import { BrowserRouter } from 'react-router-dom';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './styles/index.css';
import { Buffer } from 'buffer';
import process from 'process/browser';
import 'core-js/stable';
import 'regenerator-runtime/runtime';




// Définir Buffer et process globalement
if (typeof global !== 'undefined') {
    global.Buffer = Buffer;
    global.process = process;
} else if (typeof window !== 'undefined') {
    window.Buffer = Buffer;
    window.process = process;
}

ReactDOM.render(
  <HashRouter>
    <App />
  </HashRouter>,
  document.getElementById('root')
);




